
        'use strict';

		var angular:angular.IAngularStatic =  require('angular');
        angular.module('primo-explore.infra')
            .directive('dynamicHtml', DynamicHtml);

        function DynamicHtml($compile) {
            return {
            	restrict: 'A',
            	replace: true,
            	link: function(scope, ele, attrs) {
            		scope.$watch(attrs.dynamicHtml, function(html) {
            			ele.html(html);
            			$compile(ele.contents())(scope);
            		});
            	}
            };
        }

        DynamicHtml.$inject = ['$compile'];






// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/dynamicHtml.directive.ts